import { Button } from 'shared/ui/controls/Button'
import { AddressIcon } from 'modules/blockChain/ui/AddressIcon'
import { useWeb3 } from 'modules/blockChain/hooks/useWeb3'

import { useNFCSState } from 'modules/nfcs/hooks/useNFCSState'
import { trimMiddleString } from 'shared/utils/trimMiddleString'
import { NFCSFormStep } from 'modules/nfcs/types'

import s from './NFCSFormPartSignButton.module.scss'

type Props = {
  isLoading?: boolean
  isDisabled?: boolean
  isCurrentAddressAdded?: boolean
  showTaken?: boolean
  onAddAddress?: () => void
}

export function NFCSFormPartSignButton({
  isLoading,
  isDisabled,
  isCurrentAddressAdded,
  showTaken,
  onAddAddress,
}: Props) {
  const { walletAddress } = useWeb3()
  const { currentFormStep } = useNFCSState()

  if (!walletAddress || currentFormStep === NFCSFormStep.Finish) return null

  return (
    <Button
      fashion="greenapple"
      size={72}
      isFullWidth
      isLoading={isLoading}
      onClick={onAddAddress}
      className={s.addAddressBtn}
      isDisabled={isDisabled}
    >
      {!isCurrentAddressAdded && (
        <AddressIcon address={walletAddress!} className={s.addressIcon} />
      )}
      <span className={s.addAddressLabel}>
        {showTaken ? (
          <>
            Address{' '}
            <span className={s.addAddressHighlight}>
              {trimMiddleString(walletAddress!, 4)}
            </span>{' '}
            is already part of NFCS
          </>
        ) : isCurrentAddressAdded ? (
          <>Switch address in order to add it to the bundle</>
        ) : (
          <>
            Add{' '}
            <span className={s.addAddressHighlight}>
              {trimMiddleString(walletAddress!, 4)}
            </span>{' '}
            to the bundle
          </>
        )}
      </span>
    </Button>
  )
}
